'use client';
import { useTranslations } from 'next-intl';
import { CatIconInfo } from 'blocks-nextjs/blocks-react/components/Icons/Info';
import { CatInlineNotification } from 'blocks-nextjs/blocks-react/components/InlineNotification';
import { CatButton } from 'blocks-nextjs/blocks-react/components/Button';
import { useMyEquipmentDrawer } from '../my-equipment-drawer-context';

export const SelectedEquipmentMissingSerialBanner = () => {
  const t = useTranslations();
  const { editEquipmentDrawer } = useMyEquipmentDrawer();

  const handleOpen = () => {
    editEquipmentDrawer.openDrawer();
  };

  return (
    <div className="mb-1">
      <CatInlineNotification heading={t('MISSING_SERIAL_NUMBER')}>
        <CatIconInfo slot="before" />
        {t('ADD_CAT_SERIAL_NUMBER')}
        <CatButton
          className="text-nowrap"
          slot="after"
          variant="ghost"
          onClick={handleOpen}
        >
          {t('ADD_SERIAL_NUMBER_NEW')}
        </CatButton>
      </CatInlineNotification>
    </div>
  );
};
